import jwt_decode from 'jwt-decode'

const tokenDecode = (token) => {
  if (!token || typeof token !== 'string') {
    return null
  }
  try {
    const payload = jwt_decode(token)
    if (!payload) return null
    if (
      typeof payload.exp === 'number' &&
      payload.exp * 1000 < Date.now()
    ) {
      return null
    }
    return payload.user_id ?? null
  } catch (e) {
    return null
  }
}

export default tokenDecode
